import { combineReducers } from 'redux';
import { config } from './config';
import { page } from './page';
import { actionBar } from '../actionbar/reducer';
export const createReducer = (asyncReducers) => combineReducers({
    config,
    page,
    actionBar,
    ...asyncReducers,
});
//# sourceMappingURL=index.js.map